import Vue from 'vue';
import Vuetify from 'vuetify/lib';

Vue.use(Vuetify);

export default new Vuetify({
  icons: {
    iconfont: 'mdi',
  },
  theme: {
    themes: {
      dark: {
        primary: '#00A6CA',
        secondary: '#FCD800',
        accent: '#A9A9A9',
        info: '#A9D161',
        success: '#A9D161',
        error: '#E04025',
        warning: '#F17123',
        background: '#FFFFFF',
      },
      light: {
        primary: '#00A6CA',
        secondary: '#FCD800',
        accent: '#A9A9A9',
        info: '#A9D161',
        success: '#A9D161',
        error: '#E04025',
        warning: '#F17123',
        background: '#FFFFFF',
      },
    },
    options: {
      cspNonce: 'f4Yn2Nr3YWRt4er5',
    },
  },
});
